import { Api } from "./api"
export * from "./api-result"
export * from "./api-res-type"
export * from "./api-parameters-type"
export * from "./api-error-code-type"
export default new Api()

